import styled from 'styled-components';
import { body2, caption, colors, heading5, spacing, subtitle2 } from 'ui/theme';

export const PageSettings = styled.div`
  margin-top: ${spacing.plusHalf};

  div[data-test^='form-field'] {
    margin-bottom: ${spacing.plusHalf};

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const PageSettingsTitle = styled.div`
  ${subtitle2}
  color: ${colors.textPrimary};
  margin-bottom: ${spacing.base};
`;

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.x4} 0;
  text-align: center;
  color: ${colors.textPrimary};
`;

export const IconContainer = styled.div`
  margin-bottom: ${spacing.plusHalf};

  &[data-icon='error'] {
    margin-bottom: ${spacing.half};
  }

  &[data-icon='success'] {
    transform: scale(1.5);
  }

  circle {
    stroke-width: 2;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.half};
  margin-bottom: ${spacing.base};
`;

export const Title = styled.div`
  ${heading5}
`;

export const Description = styled.div`
  ${body2}
`;

export const LinkWrapper = styled.div`
  ${caption}
`;
